// extracted by mini-css-extract-plugin
module.exports = {"inline-loader":"app_inline-loader__1ktJF","spin":"app_spin__KvOHr","base":"app_base__I2YhS","with-nav-menu":"app_with-nav-menu__1_qy-","eightshimmer":"app_eightshimmer__cKt0w"};